import { APPLICANT, IRB, SECRETARY } from './lookup';
import AddApplication from 'components/Application/TeamMemberForm';

import AccountActivation from 'components/Login/accountActivation';
import ResetPassword from 'components/Login/resetPassword';
import ReviewFeedback from 'components/Application/ReviewFeedback';
import ApplicationDetail from 'components/Application/InitialApplication';
import ApplicationHistory from 'components/ApplicationHistory';
import ChangeDelegation from 'components/ChangeDelegation';
import { getIconLookup, getPathComponent } from './menuLookup';
import ProgressReport from 'components/ProgressReport';
import FinalReport from 'components/FinalReport';
import SAEReport from 'components/SAEReport';
import SUSARReport from 'components/SUSARReport';
import MiscellaneousReport from 'components/MiscellaneousReport';
import ConfirmResult from 'components/Review/ConfirmResult';
import ProtocolDeviation from 'components/ProtocolDeviation';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import ArrangeMeeting from 'components/Review/ArrangeMeeting/ArrangeForm';
import ReviewerFeedback from 'components/Review/ReviewerFeedback';
import CTCCTISubmissionForm from 'components/CTCCTISubmissionForm';
import ViewCTCCTISubmissionDetail from 'components/CTCCTISubmissionForm/ViewCTCCTISubmissionDetail';

const Placeholder = () => <div>Pending to implement</div>;

const NotFound = () => {
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        history.push(`/?redirect=${location.pathname}`);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <div>test</div>;
};

export const getDefaultRoute = (role) => {
    return [
        {
            component: AddApplication,
            path: '/applications/new',
            showInRoles: [APPLICANT],
            hiddenInDrawer: true,
        },
        {
            component: ChangeDelegation,
            path: '/applications/change-delegation',
            hiddenInDrawer: true,
            // showInRoles: []
        },
        {
            component: AddApplication,
            path: '/applications/clone',
            // name: 'Clone Application',
            showInRoles: [APPLICANT],
            hiddenInDrawer: true,
        },
        {
            component: ApplicationDetail,
            path: '/applications/initial-application-form',
            name: 'Initial Application',
            showInRoles: ['all'],
            hiddenInDrawer: true,
        },
        // {
        //     component: ApplicationLayout,
        //     path: '/applications/institution-list',
        //     // name: 'Institution list',
        //     showInRoles: [REVIEWER],
        //     hiddenInDrawer: true,
        // },
        {
            component: ApplicationHistory,
            path: '/applications/application-history',
            showId: true,
            showInRoles: [],
            // name: 'Application History',
            hiddenInDrawer: true,
        },
        {
            component: ApplicationDetail,
            path: '/applications/create-application-amendment',
            showId: true,
            showInRoles: [APPLICANT],
            name: 'Application Amendment',
            hiddenInDrawer: true,
        },
        {
            component: ApplicationDetail,
            path: '/post-approval-document/application-amendment-detail',
            showId: true,
            showInRoles: [APPLICANT],
            name: 'Application Amendment',
            hiddenInDrawer: true,
        },
        {
            component: ReviewFeedback,
            path: '/applications/review-feedback',
            showId: true,
            showInRoles: [SECRETARY, IRB],
            name: 'Application Review Feedback',
            hiddenInDrawer: true,
        },
        {
            component: AccountActivation,
            path: '/user/account-activation',
            name: 'Account Activation',
            showInRoles: ['all'],
            hiddenInDrawer: true,
        },
        {
            component: ResetPassword,
            path: '/user/reset-password',
            name: 'Reset Password',
            showInRoles: ['all'],
            hiddenInDrawer: true,
        },
        {
            component: ProgressReport,
            path: '/progress-report',
            hiddenInDrawer: true,
            name: 'Progress Report',
        },
        {
            component: FinalReport,
            path: '/final-report',
            hiddenInDrawer: true,
            name: 'Final Report',
        },
        {
            component: SAEReport,
            path: '/SAE-report',
            hiddenInDrawer: true,
            name: 'SAE Report',
        },
        {
            component: SUSARReport,
            path: '/SUSAR-report',
            hiddenInDrawer: true,
            name: 'SUSAR Report',
        },
        {
            component: MiscellaneousReport,
            path: '/miscellaneous-report',
            hiddenInDrawer: true,
            name: 'Miscellaneous Report',
        },
        {
            component: ConfirmResult,
            path: '/applications/confirm-review-result',
            hiddenInDrawer: true,
            name: 'Confirm Review Result',
        },
        {
            component: ConfirmResult,
            path: '/post-approval-document/confirm-review-result',
            hiddenInDrawer: true,
            name: 'Confirm Review Result',
        },
        {
            component: ProtocolDeviation,
            path: '/protocol-deviation',
            hiddenInDrawer: true,
            name: 'Protocol Deviation',
        },
        {
            component: CTCCTISubmissionForm,
            path: '/ctc-cti',
            hiddenInDrawer: true,
            name: 'CTC/CTI Submission',
        },
        {
            component: ViewCTCCTISubmissionDetail,
            path: '/view-ctc',
            hiddenInDrawer: true,
            name: 'View CTC/CTI Submission Detail',
        },
        {
            component: ViewCTCCTISubmissionDetail,
            path: '/view-cti',
            hiddenInDrawer: true,
            name: 'View CTC/CTI Submission Detail',
        },
        {
            component: ArrangeMeeting,
            path: '/review/arrange-meeting',
            hiddenInDrawer: true,
            name: 'Arrange Meeting',
        },
        {
            component: ReviewerFeedback,
            path: '/view-reviewer-feedback',
            hiddenInDrawer: true,
            name: 'Reviewer Feedback',
        },

        {
            component: NotFound,
            path: '*',
            hiddenInDrawer: true,
        },
    ];
};

export const getCombineRoute = (menu, role) => {
    // role is mandatory for the routing;
    if (!role) {
        return [];
    }

    const formattedRoute = [];

    menu?.data?.forEach((item) => {
        const route = {
            // component: Landing,
            path: item.url,
            name: item.desc,
            icon: getIconLookup(item.iconClass),
            isLoginRequired: true,
            exact: true,
            hiddenInDrawer: false,
            subRoute: [],
            showInRoles: [role],
        };

        item.subRoute.forEach((subRouteItem) => {
            const path = item.url + subRouteItem.url;
            let component = getPathComponent(path) ?? Placeholder;

            route.subRoute.push({
                component,
                path: subRouteItem.url,
                name: subRouteItem.desc,
                showInRoles: [role],
            });
        });

        if (route.subRoute.length === 0) {
            let component = getPathComponent(item.url) ?? Placeholder;
            route.component = component;
        }

        formattedRoute.push(route);
    });

    formattedRoute.push(...getDefaultRoute());

    return formattedRoute;
};
